exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-template-general-js": () => import("./../../../src/templates/template-general.js" /* webpackChunkName: "component---src-templates-template-general-js" */),
  "component---src-templates-template-inicio-js": () => import("./../../../src/templates/template-inicio.js" /* webpackChunkName: "component---src-templates-template-inicio-js" */)
}

